import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import SuburbServicePage from "./pages/SuburbServicePage"; // SEO suburb × service
import { SEO_PAGES } from "./lib/seoPageRegistry";
import HubPage from "./pages/hubs/HubPage";                    // Global SEO — programme/country hubs
import BlogIndexPage from "./pages/blog/BlogIndexPage";        // Knowledge Hub index
import BlogArticlePage from "./pages/blog/BlogArticlePage";    // Knowledge Hub articles
import NotFoundPage from "./pages/NotFoundPage";               // Custom 404
import TutorApplicationV4 from "./pages/TutorApplicationV4"; // V4 PLATFORM REBUILD
import TutorApplicationV5 from "./pages/TutorApplicationV5"; // V5 CLEAN REBUILD
import TutorApplicationSuccessV5 from "./pages/TutorApplicationSuccessV5"; // V5 SUCCESS PAGE
import AdminTutorApplicationsV5 from "./pages/AdminTutorApplicationsV5"; // V5 ADMIN VIEW
import StudentEnquiryV4 from "./pages/StudentEnquiryV4"; // V4 PLATFORM REBUILD
import AdminDashboardV4 from "./pages/AdminDashboardV4"; // V4 PLATFORM REBUILD
import AdminDashboardV5 from "./pages/AdminDashboardV5"; // V5 ENHANCED (PREVIEW)
import TutorDirectoryV4 from "./pages/TutorDirectoryV4"; // V4 PLATFORM REBUILD
import TutorProfileV4 from "./pages/TutorProfileV4"; // V4 TUTOR PROFILE PAGE
import ResourcesHub from "./pages/ResourcesHub"; // STUDENT RESOURCE PORTAL
import ResourceCategory from "./pages/ResourceCategory"; // RESOURCE CATEGORY PAGES
import TestRunner from "./pages/TestRunner"; // PRACTICE TEST ENGINE
import SimulatedExam from "./pages/SimulatedExam"; // SIMULATED EXAM MODE
import ApplicationSuccessPage from "./pages/ApplicationSuccessPage";
import AdminDashboard from "./pages/AdminDashboard";
import AdminDashboardComplete from "./pages/AdminDashboardComplete"; // COMPLETE ADMIN DASHBOARD
import TutorDirectoryPage from "./pages/TutorDirectoryPage";
import StudentEnrollmentPage from "./pages/StudentEnrollmentPage";
import EnrollmentSuccessPage from "./pages/EnrollmentSuccessPage";
import AdminStudentManagementPage from "./pages/AdminStudentManagementPage";
// PackagesPage (legacy Stripe checkout) removed 2026-02-26 — replaced by Paystack flow.
import PaymentPage from "./pages/PaymentPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PaymentCancelPage from "./pages/PaymentCancelPage";
import DonatePage from "./pages/DonatePage";
import AdminPaymentsPage from "./pages/AdminPaymentsPage";
import AdminMigrationsPanel from "./pages/AdminMigrationsPanel";
import EmailRedirectPanel from "./pages/EmailRedirectPanel";
import AdminTutorApplicationsView from "./pages/AdminTutorApplicationsView";
import AdminLoginPage from "./pages/AdminLoginPage";
import ManualTutorApprovalPage from "./pages/ManualTutorApprovalPage";

// Phase 4 — Unified Winhouse Portal (student / tutor / admin accounts)
import PortalLoginPage from "./pages/portal/PortalLoginPage";
import ForgotPasswordPage from "./pages/portal/ForgotPasswordPage";
import ResetPasswordPage from "./pages/portal/ResetPasswordPage";
import StudentDashboardPage from "./pages/portal/StudentDashboardPage";
import LearningCentrePage from "./pages/portal/LearningCentrePage";
import ExamCentrePage from "./pages/portal/ExamCentrePage";
import TutorDashboardPage from "./pages/portal/TutorDashboardPage";
import AdminUsersPage from "./pages/portal/AdminUsersPage";
import AdminV5StudentsPage from "./pages/AdminV5StudentsPage";
import StaffHubPage from "./pages/portal/StaffHubPage";
import StudentSignupPage from "./pages/portal/StudentSignupPage";
import TutorSignupPage from "./pages/portal/TutorSignupPage";
import TutorForceChangePasswordPage from "./pages/portal/TutorForceChangePasswordPage";
import StaffSignupPage from "./pages/portal/StaffSignupPage";
import AdminAccessRequestsPage from "./pages/portal/AdminAccessRequestsPage";
import AdminBookingRequestsPage from "./pages/portal/AdminBookingRequestsPage";
import StudentBookingPage from "./pages/portal/StudentBookingPage";
import TutorSchedulePage from "./pages/portal/TutorSchedulePage";

// GMAT AI Learning System — Phase 1 (isolated module under /gmat and /admin/gmat)
import GmatLandingPage from "./pages/gmat/GmatLandingPage";
import GmatDashboardPage from "./pages/gmat/GmatDashboardPage";
import GmatPracticePage from "./pages/gmat/GmatPracticePage";
import GmatMockTestPage from "./pages/gmat/GmatMockTestPage";
import GmatProfilePage from "./pages/gmat/GmatProfilePage";
import AdminGmatPanel from "./pages/gmat/AdminGmatPanel";

// IELTS AI Learning System — Phase 1 (isolated module under /ielts and /admin/ielts)
import IeltsLandingPage from "./pages/ielts/IeltsLandingPage";
import IeltsDashboardPage from "./pages/ielts/IeltsDashboardPage";
import IeltsPracticePage from "./pages/ielts/IeltsPracticePage";
import IeltsMockTestPage from "./pages/ielts/IeltsMockTestPage";
import IeltsProfilePage from "./pages/ielts/IeltsProfilePage";
import AdminIeltsPanel from "./pages/ielts/AdminIeltsPanel";

// Selective Entry Learning Centre — Phase 6E (public site)
import SelectiveEntryLandingPage from "./pages/selective/SelectiveEntryLandingPage";
// Phase 6E.1 — Public Selective Entry Resources page (polished, live data)
import SelectiveEntryResourcesPage from "./pages/selective/SelectiveEntryResourcesPage";

// Phase 5F.2 — Public tokenized payment link
import PublicPaymentLinkPage from "./pages/PublicPaymentLinkPage";

// Phase 6E.2 — Unified Winhouse Dashboard foundation
import WinhouseDashboardPage from "./pages/WinhouseDashboardPage";
import IeltsWritingLandingPage from "./pages/ielts/IeltsWritingLandingPage";
import IeltsV2Page from "./pages/ielts/IeltsV2Page";
import { IeltsMockHubPage, IeltsMockSessionPage, IeltsMockResultsPage } from "./pages/ielts/IeltsMockPages";
import IeltsListeningSimulationPage from "./pages/ielts/IeltsListeningSimulationPage";
import IeltsResultsCentrePage from "./pages/ielts/IeltsResultsCentrePage";
import IeltsReadingSimulationPage from "./pages/ielts/IeltsReadingSimulationPage";
import IeltsReadingResultsPage from "./pages/ielts/IeltsReadingResultsPage";
import {
  IeltsWritingHubPage,
  IeltsWritingWorkspacePage,
  IeltsWritingResultsPage,
} from "./pages/ielts/IeltsWritingPages";
import {
  IeltsSpeakingHubPage,
  IeltsSpeakingSessionPage,
  IeltsSpeakingResultsPage,
} from "./pages/ielts/IeltsSpeakingPages";
import IeltsWritingPracticePage from "./pages/ielts/IeltsWritingPracticePage";
import IeltsWritingMockPage from "./pages/ielts/IeltsWritingMockPage";
import IeltsWritingDashboardPage from "./pages/ielts/IeltsWritingDashboardPage";
import IeltsSpeakingLandingPage from "./pages/ielts/IeltsSpeakingLandingPage";
import IeltsSpeakingPracticePage from "./pages/ielts/IeltsSpeakingPracticePage";
import IeltsSpeakingMockPage from "./pages/ielts/IeltsSpeakingMockPage";
import IeltsSpeakingDashboardPage from "./pages/ielts/IeltsSpeakingDashboardPage";

// WINHOUSE CLASSROOM — Phase 1
import ClassroomPage from "./pages/classroom/ClassroomPage";
import { StudentClassesPage, TutorClassesPage } from "./pages/classroom/ClassesLookupPages";
import AdminClassesPage from "./pages/admin/AdminClassesPage";
import AdminClassroomSettingsPage from "./pages/admin/AdminClassroomSettingsPage";

import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Analytics from "./components/analytics/Analytics";
import TimezoneAutoDetector from "./components/TimezoneAutoDetector";
import DigitalSATLandingPage from "./pages/dsat/DigitalSATLandingPage";
import PTELandingPage from "./pages/pte/PTELandingPage";
import PTEPracticePage from "./pages/pte/PTEPracticePage";
import PTESimulationPage from "./pages/pte/PTESimulationPage";
import PTEMockPage from "./pages/pte/PTEMockPage";
import PTEVocabPage from "./pages/pte/PTEVocabPage";
import PTELearnPage from "./pages/pte/PTELearnPage";
import AdminPTERestorePage from "./pages/admin/AdminPTERestorePage";
import AdminPTEReviewsPage from "./pages/admin/AdminPTEReviewsPage";
import AdminIeltsV2RestorePage from "./pages/admin/AdminIeltsV2RestorePage";
import DSATAttemptPage from "./pages/dsat/DSATAttemptPage";
import { DSATAttemptsArchivePage, DSATReviewPage } from "./pages/dsat/DSATReviewPages";
import TutorDSATPage from "./pages/dsat/TutorDSATPage";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Analytics />
          <TimezoneAutoDetector />
          <Routes>
            <Route path="/" element={<LandingPage />} />

            {/* Auto-generated suburb × service SEO landing pages.
                Data source: src/lib/seoPageRegistry.js — add a suburb there
                and 3 new pages appear automatically (IELTS / VCE / Maths). */}
            {SEO_PAGES.map((page) => (
              <Route
                key={page.path}
                path={page.path}
                element={<SuburbServicePage page={page} />}
              />
            ))}
            
            {/* ==================== V5 CLEAN REBUILD TESTING ==================== */}
            {/* New isolated tutor application system - Testing before cutover */}
            <Route path="/become-tutor-v5" element={<TutorApplicationV5 />} />
            <Route path="/tutor-application-success" element={<TutorApplicationSuccessV5 />} />
            <Route path="/admin/tutor-applications-v5" element={
              <ProtectedRoute requireAdmin={true}>
                <AdminTutorApplicationsV5 />
              </ProtectedRoute>
            } />
            
            {/* ==================== PRODUCTION V4 ROUTES ==================== */}
            {/* Clean, stable, fully tested system - Live on all domains */}
            
            {/* Main Tutor Application - V4 */}
            <Route path="/become-tutor" element={<TutorApplicationV4 />} />
            <Route path="/apply" element={<TutorApplicationV4 />} />
            <Route path="/apply-v4" element={<TutorApplicationV4 />} />
            
            {/* Main Student Enquiry - V4 */}
            <Route path="/get-started" element={<StudentEnquiryV4 />} />
            <Route path="/find-tutor" element={<StudentEnquiryV4 />} />
            <Route path="/enquire" element={<StudentEnquiryV4 />} />
            <Route path="/enquire-v4" element={<StudentEnquiryV4 />} />
            
            {/* Public Tutor Directory - V4 */}
            <Route path="/tutors" element={<TutorDirectoryV4 />} />
            <Route path="/tutors-v4" element={<TutorDirectoryV4 />} />
            <Route path="/tutors/:id" element={<TutorProfileV4 />} />
            
            {/* Student Resource Portal */}
            <Route path="/resources" element={<ResourcesHub />} />
            {/* Phase 6E.1 — Polished Selective Entry resources (must precede the catch-all :category) */}
            <Route path="/resources/selective-entry" element={<SelectiveEntryResourcesPage />} />
            <Route path="/resources/selective" element={<SelectiveEntryResourcesPage />} />
            <Route path="/resources/digital-sat" element={<DigitalSATLandingPage />} />
            <Route path="/resources/pte-academic" element={<PTELandingPage />} />
            <Route path="/resources/pte-academic/learn" element={<PTELearnPage />} />
            <Route path="/resources/pte-academic/learn/:taskType" element={<PTELearnPage />} />
            <Route path="/resources/pte-academic/practice/:taskType" element={<PTEPracticePage />} />
            <Route path="/pte/simulation/:section" element={<PTESimulationPage />} />
            <Route path="/pte/mock/:variant" element={<PTEMockPage />} />
            <Route path="/pte/vocab" element={<PTEVocabPage />} />
            <Route path="/admin/pte-restore" element={
              <ProtectedRoute requireAdmin={true}>
                <AdminPTERestorePage />
              </ProtectedRoute>
            } />
            <Route path="/admin/pte-reviews" element={
              <ProtectedRoute requireAdmin={true}>
                <AdminPTEReviewsPage />
              </ProtectedRoute>
            } />
            <Route path="/admin/ielts-v2-restore" element={
              <ProtectedRoute requireAdmin={true}>
                <AdminIeltsV2RestorePage />
              </ProtectedRoute>
            } />
            <Route path="/resources/ielts" element={<IeltsV2Page />} />
            <Route path="/resources/ielts/listening/simulation" element={<IeltsListeningSimulationPage />} />
            <Route path="/resources/ielts/results/:attempt_id" element={<IeltsResultsCentrePage />} />
            <Route path="/resources/ielts/reading/simulation" element={<IeltsReadingSimulationPage />} />
            <Route path="/resources/ielts/reading/results/:attempt_id" element={<IeltsReadingResultsPage />} />
            <Route path="/resources/ielts/writing" element={<IeltsWritingHubPage />} />
            <Route path="/resources/ielts/writing/workspace/:aid" element={<IeltsWritingWorkspacePage />} />
            <Route path="/resources/ielts/writing/results/:aid" element={<IeltsWritingResultsPage />} />
            <Route path="/resources/ielts/speaking" element={<IeltsSpeakingHubPage />} />
            <Route path="/resources/ielts/speaking/session/:aid" element={<IeltsSpeakingSessionPage />} />
            <Route path="/resources/ielts/speaking/results/:aid" element={<IeltsSpeakingResultsPage />} />
            <Route path="/resources/ielts/mock" element={<IeltsMockHubPage />} />
            <Route path="/resources/ielts/mock/session/:mockId" element={<IeltsMockSessionPage />} />
            <Route path="/resources/ielts/mock/results/:mockId" element={<IeltsMockResultsPage />} />
            <Route path="/pte" element={<PTELandingPage />} />
            <Route path="/dsat" element={<DigitalSATLandingPage />} />
            <Route path="/dsat/attempts" element={<DSATAttemptsArchivePage />} />
            <Route path="/tutor/dsat" element={<ProtectedRoute requireRoles={['tutor', 'admin', 'owner']}><TutorDSATPage /></ProtectedRoute>} />
            <Route path="/tutor/pte" element={<ProtectedRoute requireRoles={['tutor', 'admin', 'owner']}><TutorDSATPage initialExam="pte_academic" /></ProtectedRoute>} />
            <Route path="/dsat/attempt/:attempt_id" element={<DSATAttemptPage />} />
            <Route path="/dsat/attempt/:attempt_id/review" element={<DSATReviewPage />} />
            <Route path="/resources/:category" element={<ResourceCategory />} />
            <Route path="/test/:testId" element={<TestRunner />} />
            <Route path="/exam/:examId" element={<SimulatedExam />} />
            
            {/* Success Pages */}
            <Route path="/application-success" element={<ApplicationSuccessPage />} />
            <Route path="/enrollment-success" element={<EnrollmentSuccessPage />} />
            
            {/* ==================== ADMIN ROUTES ==================== */}
            
            {/* Admin Login */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            {/* Phase 4 — Portal routes */}
            <Route path="/student/login" element={<PortalLoginPage defaultRole="student" />} />
            <Route path="/tutor/login" element={<PortalLoginPage defaultRole="tutor" />} />
            <Route path="/staff/login" element={<PortalLoginPage defaultRole="staff" />} />
            <Route path="/portal/login" element={<PortalLoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/student/signup" element={<StudentSignupPage />} />
            <Route path="/tutor/signup" element={<TutorSignupPage />} />
            <Route path="/staff/signup" element={<StaffSignupPage />} />
            <Route path="/student/dashboard" element={<StudentDashboardPage />} />
            <Route path="/student/learning" element={<LearningCentrePage />} />
            <Route path="/student/exams" element={<ExamCentrePage />} />
            <Route path="/tutor/dashboard" element={<TutorDashboardPage />} />
            <Route path="/tutor/force-change-password" element={<TutorForceChangePasswordPage />} />
            <Route path="/staff/dashboard" element={<StaffHubPage />} />
            <Route path="/admin/users" element={<ProtectedRoute requireAdmin={true}><AdminUsersPage /></ProtectedRoute>} />
            <Route path="/admin/students" element={<ProtectedRoute requireAdmin={true}><AdminV5StudentsPage /></ProtectedRoute>} />
            <Route path="/admin/v5/students" element={<ProtectedRoute requireAdmin={true}><AdminV5StudentsPage /></ProtectedRoute>} />
            <Route path="/admin/access-requests" element={<ProtectedRoute requireAdmin={true}><AdminAccessRequestsPage /></ProtectedRoute>} />
            <Route path="/admin/booking-requests" element={<ProtectedRoute requireAdmin={true}><AdminBookingRequestsPage /></ProtectedRoute>} />
            <Route path="/student/book" element={<StudentBookingPage />} />
            <Route path="/tutor/schedule" element={<TutorSchedulePage />} />
            
            {/* Main Admin Dashboard - V4 (Unified) */}
            <Route path="/admin" element={
              <ProtectedRoute requireAdmin={true}>
                <AdminDashboardV4 />
              </ProtectedRoute>
            } />
            <Route path="/admin/dashboard" element={
              <ProtectedRoute requireAdmin={true}>
                <AdminDashboardV5 />
              </ProtectedRoute>
            } />
            <Route path="/admin-v4" element={
              <ProtectedRoute requireAdmin={true}>
                <AdminDashboardV4 />
              </ProtectedRoute>
            } />

            {/* Admin Dashboard — V5 is now the default at /admin/dashboard.
                Keep /admin/v5 as an explicit alias and /admin/v4 as the fallback. */}
            <Route path="/admin/v5" element={
              <ProtectedRoute requireAdmin={true}>
                <AdminDashboardV5 />
              </ProtectedRoute>
            } />
            <Route path="/admin/v4" element={
              <ProtectedRoute requireAdmin={true}>
                <AdminDashboardV4 />
              </ProtectedRoute>
            } />

            
            {/* Legacy Admin Routes (for backward compatibility - redirect to V4) */}
            <Route path="/admin/applications" element={
              <ProtectedRoute requireAdmin={true}>
                <AdminDashboardV4 />
              </ProtectedRoute>
            } />
            <Route path="/admin/students" element={
              <ProtectedRoute requireAdmin={true}>
                <AdminDashboardV4 />
              </ProtectedRoute>
            } />
            
            {/* ==================== LEGACY ROUTES (Retired) ==================== */}
            {/* Kept for reference only - all redirect to V4 */}
            <Route path="/become-tutor-fresh" element={<TutorApplicationV4 />} />
            <Route path="/become-tutor-v3" element={<TutorApplicationV4 />} />
            <Route path="/admin/applications-v3" element={
              <ProtectedRoute requireAdmin={true}>
                <AdminDashboardV4 />
              </ProtectedRoute>
            } />
            <Route path="/admin/tutor-applications" element={
              <ProtectedRoute requireAdmin={true}>
                <AdminTutorApplicationsView />
              </ProtectedRoute>
            } />
            
            {/* Student-Tutor Matching System Routes */}
            <Route path="/tutors" element={<TutorDirectoryPage />} />
            <Route path="/get-started-old" element={<StudentEnrollmentPage />} />
            <Route path="/admin/students" element={
              <ProtectedRoute requireAdmin={true}>
                <AdminStudentManagementPage />
              </ProtectedRoute>
            } />
            
            {/* Payment & Lesson Management Routes — /packages Stripe path removed 2026-02-26 */}
            <Route path="/pay" element={<PaymentPage />} />
            <Route path="/donate" element={<DonatePage />} />
            <Route path="/payment-success" element={<PaymentSuccessPage />} />
            <Route path="/payment-cancel" element={<PaymentCancelPage />} />
            <Route path="/admin/payments" element={
              <ProtectedRoute requireAdmin={true}>
                <AdminPaymentsPage />
              </ProtectedRoute>
            } />
            <Route path="/admin/migrations" element={
              <ProtectedRoute requireAdmin={true}>
                <AdminMigrationsPanel />
              </ProtectedRoute>
            } />
            
            {/* Email Management */}
            <Route path="/admin/email-redirects" element={
              <ProtectedRoute requireAdmin={true}>
                <EmailRedirectPanel />
              </ProtectedRoute>
            } />
            
            {/* Manual Tutor Approval */}
            <Route path="/admin/manual-tutor-approval" element={
              <ProtectedRoute requireAdmin={true}>
                <ManualTutorApprovalPage />
              </ProtectedRoute>
            } />
            
            {/* New route for complete admin dashboard */}
            <Route path="/admin/dashboard" element={
              <ProtectedRoute requireAdmin={true}>
                <AdminDashboardComplete />
              </ProtectedRoute>
            } />

            {/* ==================== WINHOUSE GMAT — PHASE 1 ==================== */}
            {/* Public-facing student pages use Emergent Google Auth (per-page guard).
                /admin/gmat reuses existing platform admin JWT via ProtectedRoute. */}
            <Route path="/gmat" element={<GmatLandingPage />} />
            <Route path="/gmat/profile" element={<GmatProfilePage />} />
            <Route path="/gmat/dashboard" element={<GmatDashboardPage />} />
            <Route path="/gmat/practice" element={<GmatPracticePage />} />
            <Route path="/gmat/mock-test" element={<GmatMockTestPage />} />
            <Route path="/admin/gmat" element={
              <ProtectedRoute requireAdmin={true}>
                <AdminGmatPanel />
              </ProtectedRoute>
            } />

            {/* ==================== WINHOUSE IELTS — PHASE 1 ==================== */}
            <Route path="/ielts" element={<IeltsLandingPage />} />
            <Route path="/ielts/profile" element={<IeltsProfilePage />} />
            <Route path="/ielts/dashboard" element={<IeltsDashboardPage />} />
            <Route path="/ielts/practice" element={<IeltsPracticePage />} />
            <Route path="/ielts/mock-test" element={<IeltsMockTestPage />} />
            <Route path="/ielts/writing" element={<IeltsWritingLandingPage />} />
            <Route path="/ielts/writing/practice" element={<IeltsWritingPracticePage />} />
            <Route path="/ielts/writing/mock" element={<IeltsWritingMockPage />} />
            <Route path="/ielts/writing/dashboard" element={<IeltsWritingDashboardPage />} />
            <Route path="/ielts/speaking" element={<IeltsSpeakingLandingPage />} />
            <Route path="/ielts/speaking/practice" element={<IeltsSpeakingPracticePage />} />
            <Route path="/ielts/speaking/mock" element={<IeltsSpeakingMockPage />} />
            <Route path="/ielts/speaking/dashboard" element={<IeltsSpeakingDashboardPage />} />
            <Route path="/admin/ielts" element={
              <ProtectedRoute requireAdmin={true}>
                <AdminIeltsPanel />
              </ProtectedRoute>
            } />
            <Route path="/admin/ielts-writing" element={
              <ProtectedRoute requireAdmin={true}>
                <AdminIeltsPanel initialTab="writing" />
              </ProtectedRoute>
            } />
            <Route path="/admin/ielts-speaking" element={
              <ProtectedRoute requireAdmin={true}>
                <AdminIeltsPanel initialTab="speaking" />
              </ProtectedRoute>
            } />

            {/* ==================== SELECTIVE ENTRY — PHASE 6E ==================== */}
            <Route path="/selective" element={<SelectiveEntryLandingPage />} />
            <Route path="/selective-entry" element={<SelectiveEntryLandingPage />} />
            <Route path="/vce" element={<HubPage hubKey="vce" />} />

            {/* Phase 5F.2 — Tokenized public payment link */}
            <Route path="/pay/link/:token" element={<PublicPaymentLinkPage />} />

            {/* Phase 6E.2 — Unified Winhouse Dashboard foundation */}
            <Route path="/dashboard" element={<WinhouseDashboardPage />} />
            <Route path="/winhouse" element={<WinhouseDashboardPage />} />


            {/* WINHOUSE CLASSROOM — Phase 1 */}
            <Route path="/classroom/:roomId" element={<ClassroomPage />} />
            <Route path="/student/classes" element={<StudentClassesPage />} />
            <Route path="/tutor/classes" element={<TutorClassesPage />} />
            <Route path="/admin/classes" element={
              <ProtectedRoute requireAdmin={true}>
                <AdminClassesPage />
              </ProtectedRoute>
            } />
            <Route path="/admin/classroom-settings" element={
              <ProtectedRoute requireAdmin={true}>
                <AdminClassroomSettingsPage />
              </ProtectedRoute>
            } />

            {/* Phase SEO-Global — Knowledge Hub */}
            <Route path="/blog" element={<BlogIndexPage />} />
            <Route path="/blog/:slug" element={<BlogArticlePage />} />

            {/* Phase SEO-Global — Programme hubs (shared HubPage component) */}
            <Route path="/online-tutoring" element={<HubPage hubKey="online-tutoring" />} />
            <Route path="/online-tutoring/australia" element={<HubPage hubKey="online-tutoring/australia" />} />
            <Route path="/online-tutoring/kenya" element={<HubPage hubKey="online-tutoring/kenya" />} />
            <Route path="/online-tutoring/nigeria" element={<HubPage hubKey="online-tutoring/nigeria" />} />
            <Route path="/online-tutoring/india" element={<HubPage hubKey="online-tutoring/india" />} />
            <Route path="/pte" element={<HubPage hubKey="pte" />} />
            <Route path="/toefl" element={<HubPage hubKey="toefl" />} />
            <Route path="/sat" element={<HubPage hubKey="sat" />} />
            <Route path="/gre" element={<HubPage hubKey="gre" />} />
            <Route path="/study-abroad" element={<HubPage hubKey="study-abroad" />} />
            <Route path="/study-in-australia" element={<HubPage hubKey="study-in-australia" />} />
            <Route path="/study-in-south-korea" element={<HubPage hubKey="study-in-south-korea" />} />
            <Route path="/university-admissions" element={<HubPage hubKey="university-admissions" />} />
            <Route path="/career-guidance" element={<HubPage hubKey="career-guidance" />} />
            <Route path="/student-visa-guidance" element={<HubPage hubKey="student-visa-guidance" />} />

            {/* Custom 404 — must be last */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
